import { PublicationInfoPopover } from './PublicationInfoPopover';
import { usePublicationByProduct } from './usePublicationByProduct';

/** Publication behind a product id, for records that only carry `product_id`. */
export const PublicationByProductLink = ({
  productId,
}: {
  productId: number;
}) => {
  const publication = usePublicationByProduct(productId);

  if (!publication) return <>{productId}</>;

  return (
    <PublicationInfoPopover
      publication={publication}
      publicationId={publication.id}
    />
  );
};
